import { render } from "./AddNewWhatsAppNumber.vue?vue&type=template&id=2c3664a2&scoped=true"
import script from "./AddNewWhatsAppNumber.vue?vue&type=script&lang=js"
export * from "./AddNewWhatsAppNumber.vue?vue&type=script&lang=js"

import "./AddNewWhatsAppNumber.vue?vue&type=style&index=0&id=2c3664a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3664a2"]])

export default __exports__